import { memo } from "react";

const Book = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M17.5 15H5C4.77899 15 4.56702 15.0878 4.41074 15.2441C4.25446 15.4004 4.16667 15.6123 4.16667 15.8334C4.16667 16.0544 4.25446 16.2663 4.41074 16.4226C4.56702 16.5789 4.77899 16.6667 5 16.6667H17.5V18.3334H5C4.33696 18.3334 3.70107 18.07 3.23223 17.6011C2.76339 17.1323 2.5 16.4964 2.5 15.8334V3.33335C2.5 2.89133 2.67559 2.4674 2.98816 2.15484C3.30072 1.84228 3.72464 1.66669 4.16667 1.66669H17.5V15ZM13.3333 7.50002V5.83335H6.66667V7.50002H13.3333Z"
      fill="currentColor"
    />
  </svg>
);

export default memo(Book);
